import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGeri } from '@/lib/geri';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

export default function StockCountNew() {
  const navigate = useNavigate();
  // Geri = önceki sayfa; önceki adım yoksa eski liste adresi (bkz. lib/geri.js)
  const geri = useGeri('/erp/stock/counts');
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWh, setSelectedWh] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/warehouses').then(r => setWarehouses(r.data)).catch(() => {});
  }, []);

  const createCount = async () => {
    if (!selectedWh) return;
    setLoading(true);
    try {
      const res = await api.post('/stock/counts', { warehouse_id: selectedWh });
      toast.success('Sayim taslagi olusturuldu');
      navigate('/erp/stock/counts');
    } catch (err) { toast.error('Hata olustu'); }
    setLoading(false);
  };

  return (
    <div data-testid="stock-count-new-page">
      <div className="flex items-center gap-3 mb-6">
        <Button variant="ghost" onClick={geri} className="text-[#8a7e70] hover:text-[#1a1916]" data-testid="back-btn">
          <ArrowLeft size={18} />
        </Button>
        <h1 className="text-3xl font-bold text-[#1a1916] tracking-tight">Yeni Sayim</h1>
      </div>

      <Card className="bg-[#faf7f2] border-[#d0c4b0] shadow-sm max-w-md">
        <CardHeader className="border-b border-[#d0c4b0]">
          <CardTitle className="text-lg font-bold text-[#1a1916]">Depo Secin</CardTitle>
        </CardHeader>
        <CardContent className="p-6 space-y-4">
          <p className="text-sm text-[#8a7e70]">
            Sayim yapilacak depoyu secin. Sistem mevcut stok miktarlarinin snapshot'ini alacak.
          </p>
          <Select value={selectedWh} onValueChange={setSelectedWh}>
            <SelectTrigger className="bg-white border-[#d0c4b0]" data-testid="count-warehouse-select">
              <SelectValue placeholder="Depo secin" />
            </SelectTrigger>
            <SelectContent>
              {warehouses.map(w => <SelectItem key={w.id} value={w.id}>{w.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button onClick={createCount} disabled={!selectedWh || loading}
            className="w-full bg-[#2e2d29] text-[#f5f0e8] hover:bg-[#1a1916] font-semibold" data-testid="create-count-btn">
            {loading ? 'Olusturuluyor...' : 'Taslak Olustur'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
